import { uploadprops } from "./interface";

export const upreport: uploadprops = {
    Filename: "",
    URL: "",
    Type:"",
    Status:"",
    PostDate:""
}